import { Spacing } from '@doordash/design-language';
import { MenuSize, MenuSelectType } from './types.js';

var _MenuControlPadding, _MenuSelectTypeIcon;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var MenuControlPadding = (_MenuControlPadding = {}, _defineProperty(_MenuControlPadding, MenuSize.Small, Spacing.XxSmall), _defineProperty(_MenuControlPadding, MenuSize.Medium, Spacing.Small), _defineProperty(_MenuControlPadding, MenuSize.Large, Spacing.Large), _MenuControlPadding);
var MenuSelectTypeIcon = (_MenuSelectTypeIcon = {}, _defineProperty(_MenuSelectTypeIcon, MenuSelectType.Checkbox, {
  selected: 'CheckSquareFill',
  unselected: 'CheckSquareOffLine'
}), _defineProperty(_MenuSelectTypeIcon, MenuSelectType.Radio, {
  selected: 'RadioOnCircleFill',
  unselected: 'RadioOffCircleLine'
}), _MenuSelectTypeIcon);

export { MenuControlPadding, MenuSelectTypeIcon };
